import type { MessageSignerWalletAdapter } from '@solana/wallet-adapter-base';
import { parseWalletSignMessageResult, type OwnershipSignatureProof } from './parseWalletSignMessageResult';
import { verifyOwnershipProof } from './verifyOwnershipProof';

export type { OwnershipSignatureProof };

export async function signWalletOwnershipMessage(
  adapter: MessageSignerWalletAdapter,
  message: string,
  walletAddress: string
): Promise<OwnershipSignatureProof> {
  const encodedMessage = new TextEncoder().encode(message);
  const raw = await adapter.signMessage(encodedMessage);
  const proof = parseWalletSignMessageResult(raw);

  if (!verifyOwnershipProof({ walletAddress, message, ...proof })) {
    throw new Error(
      'Wallet returned a signature that could not be verified for this message. Try again or use another wallet.'
    );
  }

  return proof;
}
